import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from 'src/environments/environment';
import { AllSpecialitiesData } from '../_models/allSpecialities.model';
@Injectable({
  providedIn: 'root',
})
export class AllSpecialitiesApi {
  specialtyUrl = 'api/DoctorSpeciality';
  specialityReportUrl = 'api/Se7etak/Se7etakStats';

  constructor(private http: HttpClient) {}

  getSpecialityReport(FromDate, ToDate) {
    return this.http.get(`${this.specialityReportUrl}`, {
      params: {
        FromDate,
        ToDate
      },
    });
  }

  getAllSpecialties(): Observable<any> {
    return this.http.get(`${this.specialtyUrl}/GetAllSpecialities`);
  }

  addSpecialty(speciality: AllSpecialitiesData): Observable<any> {
    const formData = new FormData();
    formData.append('Image', speciality.Image, speciality.Image.name);
    formData.append('name', speciality.name);
    formData.append('ArName', speciality.arName);
    formData.append(
      'FeaturedSpecialityImage',
      speciality.FeaturedSpecialityImage
    );
    formData.append('IsActive', speciality.isActive.toString());
    formData.append('IsAnonymous', speciality.isAnonymous.toString());
    if (speciality.rank) {
      formData.append('Rank', speciality.rank.toString());
    }

    return this.http.post(`${this.specialtyUrl}/AddSpeciality`, formData);
  }

  getSpecialityById(id: number): Observable<any> {
    return this.http.get(`${this.specialtyUrl}/GetById?id=${id}`);
  }

  deleteSpeciality(id: number): Observable<any> {
    return this.http.delete(`${this.specialtyUrl}/DeleteSpeciality?id=${id}`);
  }

  updateSpecialty(speciality: AllSpecialitiesData): Observable<any> {
    const formData = new FormData();
    formData.append('id', speciality.id.toString());
    speciality.Image &&
      formData.append('Image', speciality.Image, speciality.Image.name);
    formData.append('name', speciality.name);
    formData.append('ArName', speciality.arName);
    speciality.FeaturedSpecialityImage &&
      formData.append(
        'FeaturedSpecialityImage',
        speciality.FeaturedSpecialityImage,
        speciality.FeaturedSpecialityImage.name
      );
    formData.append('IsActive', speciality.isActive.toString());
    speciality.rank && formData.append('Rank', speciality.rank.toString());
    formData.append('IsAnonymous', speciality.isAnonymous.toString());
    return this.http.put(`${this.specialtyUrl}/UpdateSpeciality`, formData);
  }

  searchByName(specialityName) {
    return this.http.get(`${this.specialtyUrl}/SearchByName/${specialityName}`);
  }
}
